<template>
  <Modal title="Excel导入请假" v-model="visible" width="880">
    <Form ref="leaveForm" class="form" :label-width="80"
      :model="leaveParam">
      <Row>
        <Col :span="12">
          <FormItem label="请假类型：" >
            <Select v-model="leaveParam.leaveType">
              <Option v-for="item in $constant.tchLeaveType"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem label="无需代课：" >
            <Select v-model="leaveParam.noProxy">
              <Option v-for="item in $constant.yesNoNum"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :span="16">
          <Form-item label="说明" prop="remark">
            <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
                   placeholder="长度不要超过100个字符"
                   v-model="leaveParam.remark"></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <el-upload
        :action="uploadLeaveUrl"
        :on-change="handleChange"
        :headers="headers"
        :on-success="handleSuccess"
        :on-progress="handleProgress"
        :before-upload="beforeUpload"
        :data="this.leaveParam"
        accept=".xls,.xlsx"
        :limit="1"
        :multiple="false"
        :show-file-list="false"
        :file-list="fileList">
        <Button type="primary"><i class="el-icon-upload el-icon--left"></i>上传请假文件</Button>
      </el-upload>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'ExportLeaveModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        uploadLeaveUrl: this.$appConfig.baseUrl + '/bookTchLeaveTime/importExe',
        fileList: [],
        headers: {},
        visible: this.value,
        loadingAdd: false,
        leaveParam: {
          noProxy: '0',
          leaveType: '',
          remark: ''
        }
      }
    },
    methods: {
      beforeUpload (file) {
        this.headers.token = this.$store.get('token')
        this.$Message.loading('文件上传中...', 0)
        return true
      },
      handleProgress (event, file, fileList) {

      },
      handleSuccess (res, file, fileList) {
        if (res.status !== 'ok') {
          this.$Message.error(res.msg)
          this.resetLeaveParam()
        } else {
          this.$Message.success('上传成功，请耐心等待并关注最终结果')
          this.fileList = []
        }
        this.visible = false
      },
      handleChange (file, fileList) {
        this.fileList = fileList.slice(-1)
      },
      resetLeaveParam () {
        this.fileList = []
        this.leaveParam.leaveType = ''
        this.leaveParam.remark = ''
      },
    },
    watch: {
      value (val) {
        this.visible = val
        if (val) {
          this.resetLeaveParam()
        }
      },
      visible (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ExportLeaveModal.vue?c40dc3dc